import {
  Link as MuiLink,
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material'
import { OPERATION_FLOW_TYPES, AUTHORITIES } from 'config'
import { useMemo, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { User } from 'types'
import { timeFormat } from 'utils/format'

import { useLoaderData } from './GroupConfig.loader'

export default function GroupList() {
  const { users, subGroups } = useLoaderData()

  const countUserAdmin = useCallback(
    (groupName) => {
      const count = { user: 0, admin: 0 }
      users
        .filter((u) => u.subGroups.includes(groupName))
        .forEach((u: User) => {
          if (u.authority === AUTHORITIES.ADMIN || u.authority === AUTHORITIES.MANAGER) {
            count.admin++
          } else {
            count.user++
          }
        })
      return count
    },
    [users],
  )
  const subGroupRows = useMemo(() => {
    return subGroups.map((g) => ({
      ...g,
      count: countUserAdmin(g.name),
    }))
  }, [subGroups, countUserAdmin])

  return (
    <div>
      <Button
        variant="outlined"
        color="primary"
        component={Link}
        to="new"
        data-testid="add-group-button"
      >
        新規追加
      </Button>
      <Table sx={{ mt: 2 }} size="small">
        <TableHead data-testid="table-head-groups">
          <TableRow sx={{ '& th': { backgroundColor: 'grey.200' } }}>
            <TableCell>グループ名</TableCell>
            <TableCell>運用フロータイプ</TableCell>
            <TableCell>登録日時</TableCell>
            <TableCell>登録担当者数</TableCell>
            <TableCell>運用管理者数</TableCell>
          </TableRow>
        </TableHead>
        <TableBody data-testid="table-body-groups">
          {subGroupRows.map((subGroup) => (
            <TableRow key={subGroup.name}>
              <TableCell component="th" scope="row">
                <MuiLink
                  color="inherit"
                  underline="always"
                  component={Link}
                  to={btoa(encodeURIComponent(subGroup.name))}
                >
                  {subGroup.name}
                </MuiLink>
              </TableCell>
              <TableCell>{OPERATION_FLOW_TYPES[subGroup.operationFlowType] || '-'}</TableCell>
              <TableCell>{subGroup.createdAt ? timeFormat(subGroup.createdAt) : '-'}</TableCell>
              <TableCell>{subGroup.count.user}</TableCell>
              <TableCell>{subGroup.count.admin}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
